<template>
  <div>
    <div class="pricing-wrapper">
    <div class="upgrade">
      <div class="card tailwind-reset">
        <div class="card-body">
          <div>
            <main class="pricing-main">
              <PricingRedesign
                ref="redesign"
                :plans="redesignPlans"
                :users="redesignUsers"
                :selected-plans="redesignSelectedPlans"
                :has-usage-history="hasUsageHistory"
                :is-migration="hasPaidCharges"
                :month-options="filterDateOptions"
                :selected-month="selectedFilterDate"
                :licenses-enabled="isLicensesEnabled"
                :due-date="redesignDueDate"
                :billing-day="redesignBillingDay"
                :is-loading="isLoadingUsage"
                :is-submitting="isLoadingPayment"
                @pick="handleRedesignPick"
                @apply-all="handleRedesignApplyAll"
                @reset-suggestions="handleRedesignResetSuggestions"
                @change-month="handleRedesignMonthChange"
                @licenses-change="handleRedesignLicensesChange"
                @submit="handleRedesignSubmit">
                <template slot="showcase">
                  <PlanShowcase
                    :plans="pricingList"
                    @assign="scrollToUserList"
                    @contact-sales="openWhatsApp" />
                </template>
                <template slot="extras">

              <!-- Modelo de IA -->
              <div v-if="hasAnyAiPlanInSubscription && isRolloutAiDropdown" class="rounded-lg border bg-card text-card-foreground shadow-sm p-6">
                <div class="ai-model-title-row mb-3">
                  <h3 class="text-lg font-semibold" style="margin: 0;">Modelo de IA</h3>
                  <span class="ai-model-info" tabindex="0" role="button" aria-label="Como o modelo de IA é aplicado">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 16v-4"></path>
                      <path d="M12 8h.01"></path>
                    </svg>
                    <span class="ai-model-info__tooltip" role="tooltip">
                      O modelo escolhido é aplicado à organização inteira e vale para <strong>todos os usuários que têm IA inclusa no plano</strong>. Ele define como a IA processa as ligações desses usuários (transcrição, resumos e análises). Usuários sem IA no plano não são afetados.
                    </span>
                  </span>
                </div>
                <div class="relative ai-model-dropdown-container">
                  <button
                    type="button"
                    role="combobox"
                    @click.stop="toggleAiModelDropdown"
                    :aria-expanded="isAiModelDropdownOpen"
                    class="flex h-10 items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 w-full">
                    <span style="pointer-events: none;">{{ selectedAiModelLabel }}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down h-4 w-4 opacity-50" aria-hidden="true">
                      <path d="m6 9 6 6 6-6"></path>
                    </svg>
                  </button>
                  <div
                    v-if="isAiModelDropdownOpen"
                    class="absolute z-50 mt-1 w-full bg-white rounded-md shadow-lg border border-input max-h-[200px] overflow-auto">
                    <div
                      v-for="model in aiModels"
                      :key="model.value"
                      @click="selectAiModel(model.value)"
                      :class="{ 'bg-muted/50': selectedAiModel === model.value }"
                      class="px-3 py-2 hover:bg-muted/50 cursor-pointer text-sm">
                      {{ model.label }}
                    </div>
                  </div>
                </div>
                <p class="text-xs text-muted-foreground mt-2 mb-0">
                  Modelo aplicado aos planos com IA inclusa.
                </p>
              </div>

                </template>
              </PricingRedesign>
            </main>
          </div>
        </div>
    </div>
  </div>
  </div>

  <!-- Botão Flutuante do WhatsApp -->
  <a
    href="#"
    target="_blank"
    rel="noopener noreferrer"
    class="whatsapp-float"
    title="Fale com nosso time comercial"
    @click.prevent="openWhatsApp">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" class="whatsapp-icon">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
    </svg>
  </a>

  <PaymentMethodModal
    :visible="showPaymentMethodModal"
    :loading="isLoadingPayment"
    :loading-label="invoiceLoadingLabel"
    :subscription-error="subscriptionError"
    :pending-invoice-data="pendingInvoiceData"
    @close="handlePaymentMethodModalClose"
    @confirm="handlePaymentMethodConfirm" />

  <FinancialDocumentModal
    :visible="showFinancialDocumentModal"
    @close="closeFinancialDocumentModal"
    @continue="handleFinancialDocumentContinue" />

  <ChargeGeneratedModal
    :visible="showChargeGeneratedModal"
    :total-formatted="chargeGeneratedTotalFormatted"
    :user-count="chargeGeneratedUserCount"
    :due-date-formatted="chargeGeneratedDueDateFormatted"
    :payment-link="chargeGeneratedPaymentLink"
    @close="handleChargeGeneratedModalClose"
    @navigate="closeChargeGeneratedModal" />

  <!-- Modal de Confirmação de Contato com Telefone -->
  <div
    v-if="showContactPhoneModal"
    class="modal-overlay"
    @click.self="closeContactPhoneModal">
    <div
      role="dialog"
      aria-describedby="subscription-pricing-modal-description"
      aria-labelledby="subscription-pricing-modal-title"
      class="modal-dialog"
      style="pointer-events: auto; max-width: 28rem;">
      <div class="flex flex-col space-y-1.5 text-center">
        <div class="flex items-center justify-center mb-4">
          <div style="width: 64px; height: 64px; border-radius: 9999px; background-color: #dcfce7; display: flex; align-items: center; justify-content: center;">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              style="color: #16a34a;">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="m9 12 2 2 4-4"></path>
            </svg>
          </div>
        </div>
        <h2 id="subscription-pricing-modal-title" style="font-size: 1.5rem; font-weight: 700; text-align: center; letter-spacing: -0.025em; margin: 0;">
          Nosso time entrará em contato para ajustar seu plano
        </h2>
        <p id="subscription-pricing-modal-description" style="text-align: center; font-size: 1rem; padding-top: 0.75rem; color: #6b7280; margin: 0;">
          Obrigado pelo seu interesse! Confirme abaixo o telefone para o contato da nossa equipe.
        </p>
      </div>
      <div class="flex flex-col items-center" style="gap: 0.25rem; padding-top: 0.75rem;">
        <label style="font-size: 0.875rem; font-weight: 700 !important; color: #374151;">WhatsApp / telefone</label>
        <input
          v-model="contactPhone"
          type="tel"
          @keydown="allowOnlyNumericKeydown($event)"
          @input="onContactPhoneInput"
          placeholder="(00) 0 0000-0000"
          :style="{
            width: '100%', maxWidth: '16rem', padding: '0.5rem 0.75rem',
            border: '2px solid ' + (contactPhone && !isContactPhoneValid ? '#dc2626' : '#2463eb'),
            borderRadius: '0.5rem', fontSize: '1rem', textAlign: 'center', outline: 'none'
          }"
        />
        <p v-if="contactPhone && !isContactPhoneValid" style="font-size: 0.75rem; color: #dc2626; margin: 0;">
          Insira um telefone válido
        </p>
        <p v-else style="font-size: 0.75rem; color: #6b7280; margin: 0;">
          Trouxemos o número cadastrado na sua conta. Edite se preferir outro.
        </p>
      </div>
      <div class="flex justify-center" style="padding-top: 0.75rem;">
        <button
          @click="confirmContactPhone"
          :disabled="!isContactPhoneValid || isUpdatingPhone"
          class="success-modal-button"
          :style="{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem',
            whiteSpace: 'nowrap', borderRadius: '0.375rem', fontSize: '0.875rem', fontWeight: '500',
            height: '2.5rem', paddingLeft: '2rem', paddingRight: '2rem',
            backgroundColor: (!isContactPhoneValid || isUpdatingPhone) ? '#93a3b8' : '#2463eb',
            color: '#ffffff', border: 'none',
            cursor: (!isContactPhoneValid || isUpdatingPhone) ? 'not-allowed' : 'pointer'
          }">
          {{ isUpdatingPhone ? 'Salvando...' : 'Confirmar contato' }}
        </button>
      </div>
      <button
        type="button"
        style="position: absolute; right: 1rem; top: 1rem; border-radius: 0.125rem; opacity: 0.7; background: transparent; border: none; cursor: pointer; padding: 0.25rem;"
        @click="closeContactPhoneModal">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          style="color: #6b7280;">
          <path d="M18 6 6 18"></path>
          <path d="m6 6 12 12"></path>
        </svg>
      </button>
    </div>
  </div>

  <!-- Modal de Alteração de Data de Vencimento -->
  <div
    v-if="showDueDateModal"
    class="modal-overlay"
    @click.self="closeDueDateModal">
      <div
        role="dialog"
        class="modal-dialog"
        style="pointer-events: auto;">
        <div class="flex flex-col space-y-1.5 text-center sm:text-left">
          <h2 class="text-lg font-semibold leading-none tracking-tight">Alterar Data de Vencimento</h2>
          <p class="text-sm text-muted-foreground">Selecione o dia do mês para vencimento das próximas cobranças.</p>
        </div>

        <div class="bg-amber-50 border border-amber-200 rounded-lg p-3 mt-2">
          <div class="flex items-start gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-triangle-alert h-4 w-4 text-amber-600 mt-0.5 flex-shrink-0">
              <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
              <path d="M12 9v4"></path>
              <path d="M12 17h.01"></path>
            </svg>
            <div class="text-sm text-amber-800 space-y-2">
              <p class="mb-1 text-amber-800"><strong> Sua primeira cobrança vence hoje. </strong> A alteração do dia de vencimento abaixo será aplicada somente a partir da próxima cobrança.</p>
              <p class="text-xs text-amber-800">O vencimento corresponde ao início de cada ciclo. O não pagamento acarretará em suspensão dos serviços.</p>
            </div>
          </div>
        </div>

        <div class="py-3">
          <label class="text-sm font-medium mb-2 block">Novo dia de vencimento:</label>
          <div class="relative">
            <button
              type="button"
              role="combobox"
              @click="toggleDayDropdown"
              :aria-expanded="isDayDropdownOpen"
              class="flex h-10 items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 w-full">
              <span style="pointer-events: none;">Dia {{ String(previewBillingDay || 1).padStart(2, '0') }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down h-4 w-4 opacity-50" aria-hidden="true">
                <path d="m6 9 6 6 6-6"></path>
              </svg>
            </button>
            <div
              v-if="isDayDropdownOpen"
              class="absolute z-50 mt-1 w-full bg-white rounded-md shadow-lg border border-input max-h-[200px] overflow-auto">
              <div
                v-for="day in daysOfMonth"
                :key="day"
                @click="selectBillingDay(day)"
                :class="{ 'bg-muted/50': previewBillingDay === day }"
                class="px-3 py-2 hover:bg-muted/50 cursor-pointer text-sm">
                Dia {{ String(day).padStart(2, '0') }}
              </div>
            </div>
          </div>
        </div>

        <div class="border rounded-lg overflow-hidden">
          <div class="bg-muted/50 px-3 py-2 border-b flex justify-between items-center">
            <span class="text-xs font-medium text-muted-foreground">Simulação das próximas cobranças</span>
          </div>
          <div class="divide-y">
            <div class="px-3 py-2.5 bg-green-50">
              <div class="flex justify-between items-center">
                <div>
                  <span class="text-sm font-medium text-green-700">Cobrança atual</span>
                  <p class="text-xs text-green-600" v-html="currentCycleDisplay"></p>
                </div>
                <div class="text-right">
                  <span class="text-sm font-semibold text-green-700">{{ formatCurrency(totalMonthlyFee) }}</span>
                  <p class="text-xs text-green-600">Venc: {{ formattedToday }}</p>
                </div>
              </div>
            </div>
            <div class="px-3 py-2.5">
              <div class="flex justify-between items-center">
                <div>
                  <span class="text-sm font-medium">Próxima cobrança</span>
                  <p class="text-xs text-muted-foreground" v-html="nextCycleDisplay"></p>
                </div>
                <div class="text-right">
                  <span class="text-sm font-semibold text-primary">{{ formatCurrency(baseMonthlyFee) }}</span>
                  <p class="text-xs text-muted-foreground">Venc: {{ nextDueDate }}</p>
                </div>
              </div>
            </div>
            <div class="px-3 py-2.5 bg-muted/30">
              <div class="flex justify-between items-center">
                <div>
                  <span class="text-sm font-medium text-muted-foreground">Cobrança seguinte</span>
                  <p class="text-xs text-muted-foreground" v-html="followingCycleDisplay"></p>
                </div>
                <div class="text-right">
                  <span class="text-sm font-semibold text-muted-foreground">{{ formatCurrency(baseMonthlyFee) }}</span>
                  <p class="text-xs text-muted-foreground">Venc: {{ followingDueDate }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex justify-end gap-2 pt-2">
          <button
            class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground"
            @click="closeDueDateModal">
            Cancelar
          </button>
          <button
            class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 bg-primary text-primary-foreground hover:bg-primary/90"
            @click="saveBillingDaySelection">
            Confirmar
          </button>
        </div>

        <button
          type="button"
          class="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
          @click="closeDueDateModal">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x h-4 w-4">
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
          </svg>
          <span class="sr-only">Close</span>
        </button>
      </div>
  </div>
  </div>
</template>

<script>
import {
  processUsersMonthlyUsage,
  getInitialSelectedFilterDate,
  getMonthName,
  getFilterDateOptions
} from '../../services/pricing'
import { loadAndMapOffers } from '../../services/pricing-offers'
import { getPlanOriginalPrice } from '../../utils/plan-original-price'
import { getPlanCardClasses as getPlanCardClassesUtil, getPlanBadgeClasses as getPlanBadgeClassesUtil, ensureTailwindCdn } from '../../utils/subscription-plan-styles'
import { formatCurrency as formatCurrencyUtil } from '../../utils/currency'
import { convertSecondsToCustomTimeFormat } from '../../utils/datetime'
import { formatPercentage } from '../../utils/number'
import { billingService } from '../../services/billing'
import { getInviteEligibility, resolveInviteEligibilityMaxUsers, isOrganizationUserLimitExempt } from '../../services/invite-eligibility'
import { getAiModels } from '../../services/ai-models'
import { labelForAiModel, AI_MODEL_DEFAULT } from '../../utils/ai-model-labels'
import { formatPhoneMask, phoneDigitsOnly, allowOnlyNumericKeydown, isValidPhone, maskNationalPhone } from '../../utils/phone'
import loopback from '../../services/loopback'
import { calculateProrata } from '../../services/subscription'
import { triggerUserDataUpdateWebhook } from '../../services/user-data-update-webhook'
import axios from 'axios'
import moment from 'moment-timezone'
import 'moment/locale/pt-br'
import PaymentMethodModal from './PaymentMethodModal.vue'
import ChargeGeneratedModal from './ChargeGeneratedModal.vue'
import FinancialDocumentModal from './FinancialDocumentModal.vue'
import { runSubscriptionCheckout } from './subscription-checkout'
import { salesWebhookUrlFor } from '@/utils/whatsapp'
import PricingRedesign from './PricingRedesign.vue'
import PlanShowcase from './PlanShowcase.vue'
import { planBadgePalette } from '../../utils/emailHtml'

const LICENSES_RELOAD_DEBOUNCE_MS = 300

// Os grupos vêm indexados pelo código do plano sugerido — quais existem depende do que o
// billing oferta. Só garante que cada valor é um array antes de a tela iterar sobre eles.
function normalizeUsageGroups (usersUsage) {
  if (!usersUsage || typeof usersUsage !== 'object') return {}
  return Object.keys(usersUsage).reduce((groups, planCode) => {
    groups[planCode] = Array.isArray(usersUsage[planCode]) ? usersUsage[planCode] : []
    return groups
  }, {})
}

export default {
  name: 'SubscriptionPricing',
  components: {
    PaymentMethodModal,
    ChargeGeneratedModal,
    FinancialDocumentModal,
    PricingRedesign,
    PlanShowcase
  },
  data () {
    return {
      pricingList: [],
      // Grupos de sugestão, indexados pelo código do plano — montados a partir do que o
      // billing devolve, nunca por uma lista fixa de planos.
      usersMonthlyUsage: {},
      selectedFilterDate: null,
      filterDateOptions: getFilterDateOptions(),
      isLoadingUsage: false,
      userSelectedPlans: {},
      isFirstBilling: true,
      selectedBillingDay: 10,
      showDueDateModal: false,
      previewBillingDay: 10,
      isDayDropdownOpen: false,
      billingCalculation: null,
      cycleCalculation: null,
      isLoadingBilling: false,
      billingError: null,
      billingRequestId: 0,
      licensesReloadTimer: null,
      isLoadingPayment: false,
      rechargeActiveUsersLimit: null,
      inviteEligibilityCutoffDate: null,
      canInvite: true,
      showPaymentMethodModal: false,
      showChargeGeneratedModal: false,
      showFinancialDocumentModal: false,
      pendingConfirmPayload: null,
      subscriptionError: null,
      chargeGeneratedPaymentLink: '',
      chargeGeneratedNetValue: null,
      chargeGeneratedDueDate: null,
      invoiceLoadingLabel: 'Gerando cobrança...',
      pendingInvoiceData: null,
      aiModels: [],
      selectedAiModel: null,
      isAiModelDropdownOpen: false,
      isRolloutAiDropdown: false,
      showContactPhoneModal: false,
      contactPhone: '',
      isUpdatingPhone: false,
      journeyActive: false,
      journeyEmittedPayment: false,
      journeyAbandonmentSent: false,
      journeyContext: null,
      // Licenças adicionais: a interface está pronta, o backend é ticket
      // separado (TEL-2147, PRD seção 10). Fica desligado até o endpoint
      // existir — ligar antes disso deixaria o cliente reservar licença que
      // não seria cobrada nem criada.
      reservedLicenses: {},
      hasPaidCharges: false
    }
  },
  created () {
    this.selectedFilterDate = getInitialSelectedFilterDate()
  },
  mounted () {
    this.$nextTick(() => {
      if (this.isFirstBilling) {
        const todayDay = moment().date()
        const closestDay = this.getClosestAvailableBillingDay(todayDay)
        this.selectedBillingDay = closestDay
        this.previewBillingDay = closestDay
      }

      ensureTailwindCdn()
      document.addEventListener('click', this.handleOutsideClick)

      this.loadInviteEligibility()
      // A lista só existe depois das ofertas: até lá mostra "Carregando" e não "nenhum usuário".
      this.isLoadingUsage = true
      this.loadPricingOffers().then(() => this.loadUsersMonthlyUsage())
      this.fetchAiModels()
      this.loadRolloutAiDropdown()
      this.loadPaidChargesFlag()
    })
  },
  beforeDestroy () {
    if (this.licensesReloadTimer !== null) clearTimeout(this.licensesReloadTimer)
    this.sendJourneyAbandonment()
    document.removeEventListener('click', this.handleOutsideClick)
    document.body.style.overflow = ''
  },
  computed: {
    isContactPhoneValid () {
      return isValidPhone(this.contactPhone)
    },
    showRechargeModelUserLimitBullet () {
      const organization = this.$store.state.auth.organization || {}
      if (isOrganizationUserLimitExempt(organization)) return false
      const createdAtRaw = organization.created_at || organization.createdAt
      if (this.inviteEligibilityCutoffDate && createdAtRaw) {
        const createdAt = new Date(createdAtRaw)
        const cutoffDate = new Date(this.inviteEligibilityCutoffDate)
        if (!isNaN(createdAt.getTime()) && !isNaN(cutoffDate.getTime())) {
          return createdAt >= cutoffDate
        }
      }
      return !this.canInvite
    },
    rechargeActiveUsersLimitLabel () {
      if (this.rechargeActiveUsersLimit === null) return 'N/D'
      return this.rechargeActiveUsersLimit
    },
    redesignPlans () {
      return this.pricingList.map(plan => ({
        code: plan.code,
        name: plan.name,
        monthlyFee: plan.monthlyFee,
        // 0 = não realiza ligações · null = ilimitado
        limitMinutes: plan.minutes,
        hasIa4com: plan.hasIa4com,
        // Para os planos do topo da tela: mesmo preço riscado e mesmas features da tela de planos.
        originalPrice: getPlanOriginalPrice(plan),
        features: plan.features || []
      }))
    },
    redesignUsers () {
      const flattened = Object.keys(this.usersMonthlyUsage).reduce((acc, suggestedPlan) => {
        return acc.concat(this.usersMonthlyUsage[suggestedPlan].map(user => {
          const key = user.email || user.extension
          return {
            key,
            name: user.name || key,
            email: user.email || user.extension,
            minutes: Math.floor(Number(user.seconds || 0) / 60),
            // O grupo em que o usuário caiu é a sugestão feita pelo consumo.
            suggestedPlan
          }
        }))
      }, [])
      return flattened.sort((userA, userB) => String(userA.name).localeCompare(String(userB.name), 'pt-BR'))
    },
    redesignSelectedPlans () {
      // Sem fallback para 'manager': quem não tem plano escolhido aparece como
      // "Selecione…" e segura o botão de pagamento.
      const selected = {}
      this.redesignUsers.forEach(user => {
        if (this.userSelectedPlans[user.key]) selected[user.key] = this.userSelectedPlans[user.key]
      })
      return selected
    },
    hasUsageHistory () {
      return this.totalSeconds > 0
    },
    redesignDueDate () {
      if (this.billingCalculation && this.billingCalculation.dueDate) {
        const date = moment(this.billingCalculation.dueDate)
        if (date.isValid()) return date.format('DD/MM/YYYY')
      }
      return ''
    },
    redesignBillingDay () {
      return this.effectiveBillingDay || this.selectedBillingDay
    },
    financialData () {
      return this.$store.state.auth.financialData
    },
    needsFinancialDocument () {
      const financialData = this.financialData
      if (!financialData) return true
      return financialData.status !== 'ACTIVE'
    },
    // `hasAi` aqui é a IA de transcrição/resumo, que escolhe o modelo (`aiDefaultName`).
    // Nada a ver com o IA4COM: este dropdown já valia para planos atuais.
    hasAnyAiPlanInSubscription () {
      const grouped = this.groupedUsersBySelectedPlan
      if (!grouped) return false
      return this.pricingList.some(plan =>
        plan.hasAi &&
        Array.isArray(grouped[plan.code]) &&
        grouped[plan.code].length > 0
      )
    },
    selectedAiModelLabel () {
      const found = this.aiModels.find(model => model.value === this.selectedAiModel)
      return found ? found.label : 'Selecione um modelo'
    },
    // Chaveado por TODO plano ofertado, não só pelos que a sugestão propõe: é o que leva
    // o assento escolhido até o checkout. Um plano de fora deste objeto some em silêncio
    // do payload — o cliente escolheria a variante IA4COM, pagaria, e o assento não
    // entraria na assinatura.
    groupedUsersBySelectedPlan () {
      const grouped = this.pricingList.reduce((groups, plan) => {
        groups[plan.code] = []
        return groups
      }, {})

      Object.keys(this.usersMonthlyUsage).forEach(suggestedPlanCode => {
        this.usersMonthlyUsage[suggestedPlanCode].forEach(user => {
          const selectedPlanCode = this.getUserPlan(user)
          if (grouped[selectedPlanCode]) {
            grouped[selectedPlanCode].push(user)
          }
        })
      })

      return grouped
    },
    // Um resumo por plano com usuários, na ordem em que os planos são exibidos. Substitui
    // o conjunto de computeds que existia por plano fixo e é a base de todos os totais.
    planSummaries () {
      const grouped = this.groupedUsersBySelectedPlan
      return this.pricingList.reduce((summaries, plan) => {
        const users = grouped[plan.code] || []
        if (users.length === 0) return summaries
        const seconds = users.reduce((acc, user) => acc + Number(user.seconds || 0), 0)
        const cost = users.reduce((acc, user) => acc + Number(user.cost || 0), 0)
        const monthlyFee = plan.monthlyFee * users.length
        summaries.push({
          plan,
          users,
          count: users.length,
          seconds,
          cost,
          monthlyFee,
          variability: monthlyFee - cost
        })
        return summaries
      }, [])
    },
    // Quem libera as licenças é a própria conta (organizations.seats_decoupled), não um
    // rollout à parte: conta nova nasce com a flag ligada e as antigas são migradas uma
    // a uma pelo Suporte.
    isLicensesEnabled () {
      const organization = this.$store.state.auth.organization
      if (organization === null || organization === undefined) return false
      return organization.seatsDecoupled === true
    },
    baseMonthlyFee () {
      return this.planSummaries.reduce((total, summary) => total + summary.monthlyFee, 0)
    },
    // Licenças adicionais reservadas: quantidade por plano e o que elas somam por mês.
    // Uma conta pode ter todas as pessoas no Gerencial (grátis) e mesmo assim ter
    // cobrança, porque as licenças são pagas.
    reservedLicenseQuantities () {
      const quantities = {}
      Object.keys(this.reservedLicenses || {}).forEach(planCode => {
        const quantity = Number(this.reservedLicenses[planCode])
        if (Number.isInteger(quantity) && quantity > 0) quantities[planCode] = quantity
      })
      return quantities
    },
    reservedLicensesFee () {
      return Object.keys(this.reservedLicenseQuantities).reduce((total, planCode) => {
        const plan = this.pricingList.find(item => item.code === planCode)
        if (!plan) return total
        return total + this.reservedLicenseQuantities[planCode] * Number(plan.monthlyFee)
      }, 0)
    },
    // O que a contratação vai cobrar por mês: pessoas + licenças adicionais.
    contractedMonthlyFee () {
      return this.baseMonthlyFee + this.reservedLicensesFee
    },
    suggestedBillingDay () {
      if (!this.isFirstBilling) {
        return null
      }

      const todayDay = moment().date()
      return this.getClosestAvailableBillingDay(todayDay)
    },
    effectiveBillingDay () {
      if (this.showDueDateModal) {
        return this.previewBillingDay
      }

      if (this.isFirstBilling && (!this.selectedBillingDay || this.selectedBillingDay === 10)) {
        return this.suggestedBillingDay
      }

      return this.selectedBillingDay || this.suggestedBillingDay
    },
    totalMonthlyFee () {
      if (this.billingCalculation) {
        return this.billingCalculation.proratedFee || this.billingCalculation.totalAmount || 0
      }
      return 0
    },
    canGeneratePayment () {
      return this.cycleCalculation &&
        this.billingCalculation &&
        this.usersMonthlyUsage &&
        Object.keys(this.usersMonthlyUsage).some(key => this.usersMonthlyUsage[key].length > 0)
    },
    chargeGeneratedTotalFormatted () {
      if (this.chargeGeneratedNetValue !== null && this.chargeGeneratedNetValue !== undefined) {
        return this.formatCurrency(Number(this.chargeGeneratedNetValue))
      }
      return this.formatCurrency(this.totalMonthlyFee)
    },
    chargeGeneratedUserCount () {
      return this.totalUsers
    },
    chargeGeneratedDueDateFormatted () {
      if (this.chargeGeneratedDueDate !== null && this.chargeGeneratedDueDate !== undefined && this.chargeGeneratedDueDate !== '') {
        const date = moment.utc(this.chargeGeneratedDueDate)
        return date.isValid() ? date.format('DD/MM/YYYY') : String(this.chargeGeneratedDueDate)
      }
      return '—'
    },
    totalUsers () {
      return this.planSummaries.reduce((total, summary) => total + summary.count, 0)
    },
    totalSeconds () {
      return this.planSummaries.reduce((total, summary) => total + summary.seconds, 0)
    },
    totalCost () {
      return this.planSummaries.reduce((total, summary) => total + summary.cost, 0)
    },
    totalVariability () {
      return this.planSummaries.reduce((total, summary) => total + summary.variability, 0)
    },
    percentageVariability () {
      if (this.totalCost && this.totalMonthlyFee) {
        return ((this.totalCost / this.totalMonthlyFee) - 1) * -1
      }
      return 0
    },
    hasTotalNegativeVariability () {
      return this.totalVariability <= 0
    },
    formattedCurrentBillingDueDate () {
      if (this.billingCalculation && this.billingCalculation.dueDate) {
        return moment(this.billingCalculation.dueDate).locale('pt-br').format('DD [de] MMMM [de] YYYY')
      }
      return ''
    },
    formattedToday () {
      if (this.billingCalculation && this.billingCalculation.dueDate) {
        return moment(this.billingCalculation.dueDate).format('DD/MM/YYYY')
      }
      return ''
    },
    daysOfMonth () {
      // TEL-2041: oferece 1-31 (o billing aceita o dia real e normaliza meses curtos).
      return Array.from({ length: 31 }, (_, i) => i + 1)
    },
    nextBillingCycleStartDate () {
      if (this.cycleCalculation && this.cycleCalculation.nextCycleStart) {
        return moment(this.cycleCalculation.nextCycleStart)
      }
      return null
    },
    followingBillingCycleStartDate () {
      if (this.cycleCalculation && this.cycleCalculation.nextCycleEnd) {
        return moment(this.cycleCalculation.nextCycleEnd).add(1, 'day')
      }
      return null
    },
    currentCycleDisplay () {
      if (this.cycleCalculation) {
        const start = moment(this.cycleCalculation.cycleStart)
        const end = moment(this.cycleCalculation.cycleEnd)
        return this.formatCycleDisplay(start, end)
      }
      return ''
    },
    currentPeriodDisplay () {
      if (this.cycleCalculation) {
        const start = moment(this.cycleCalculation.cycleStart)
        const end = moment(this.cycleCalculation.cycleEnd)
        return `${start.format('DD/MM')} a ${end.format('DD/MM')}`
      }
      return ''
    },
    nextCycleDisplay () {
      if (this.cycleCalculation && this.cycleCalculation.nextCycleStart) {
        const start = moment(this.cycleCalculation.nextCycleStart)
        const end = moment(this.cycleCalculation.nextCycleEnd)
        return this.formatCycleDisplay(start, end)
      }
      return ''
    },
    followingCycleDisplay () {
      if (this.cycleCalculation && this.cycleCalculation.nextDueDate && this.effectiveBillingDay) {
        const nextDueDate = moment(this.cycleCalculation.nextDueDate)

        const normalizeBillingDay = (date, billingDay) => {
          const monthDays = date.daysInMonth()
          return Math.min(billingDay, monthDays)
        }

        const followingDueDate = nextDueDate.clone().add(1, 'month')
        const normalizedFollowingDay = normalizeBillingDay(followingDueDate, this.effectiveBillingDay)
        followingDueDate.date(normalizedFollowingDay)

        const followingCycleStart = followingDueDate.clone()

        const nextAfterFollowingDueDate = followingDueDate.clone().add(1, 'month')
        const normalizedNextAfterFollowingDay = normalizeBillingDay(nextAfterFollowingDueDate, this.effectiveBillingDay)
        nextAfterFollowingDueDate.date(normalizedNextAfterFollowingDay)

        const followingCycleEnd = nextAfterFollowingDueDate.clone().subtract(1, 'day')

        return this.formatCycleDisplay(followingCycleStart, followingCycleEnd)
      }
      return ''
    },
    nextDueDate () {
      if (this.cycleCalculation) {
        return moment(this.cycleCalculation.nextDueDate).format('DD/MM/YYYY')
      }
      return ''
    },
    followingDueDate () {
      if (this.cycleCalculation && this.cycleCalculation.nextDueDate && this.effectiveBillingDay) {
        const next = moment(this.cycleCalculation.nextDueDate)
        const following = next.clone().add(1, 'month')
        const followingMonthDays = following.daysInMonth()
        const normalizedDay = Math.min(this.effectiveBillingDay, followingMonthDays)
        following.date(normalizedDay)
        return following.format('DD/MM/YYYY')
      }
      return ''
    }
  },
  methods: {
    async loadInviteEligibility () {
      const eligibility = await getInviteEligibility()
      this.rechargeActiveUsersLimit = resolveInviteEligibilityMaxUsers(eligibility)
      this.inviteEligibilityCutoffDate = eligibility ? eligibility.cutoffDate : null
      this.canInvite = eligibility && eligibility.canInvite !== false
    },
    // "Falar com o time" do banner e botão flutuante.
    openWhatsApp () {
      const organization = this.$store.state.auth.organization
      const url = salesWebhookUrlFor(organization && organization.domain)
      window.open(url, '_blank', 'noopener,noreferrer')
    },
    scrollToUserList () {
      if (this.$refs.redesign) this.$refs.redesign.scrollToUsers()
    },
    loadPricingOffers () {
      return loadAndMapOffers({ purpose: 'contract' }).then(list => {
        this.pricingList = list
      })
    },
    loadUsersMonthlyUsage () {
      this.isLoadingUsage = true
      processUsersMonthlyUsage(JSON.parse(this.selectedFilterDate), this.pricingList).then(usersUsage => {
        this.usersMonthlyUsage = normalizeUsageGroups(usersUsage)
        this.initializeUserPlans()
        this.reloadBillingData()
      }).catch(err => {
        console.error('Error loading users monthly usage', err)
      }).finally(() => {
        this.isLoadingUsage = false
      })
    },
    // Quantidade por plano para a pró-rata: pessoas MAIS licenças adicionais, porque
    // a primeira cobrança sai com as duas coisas.
    aggregateUsersByPlan () {
      const quantities = this.planSummaries.reduce((acc, summary) => {
        acc[summary.plan.code] = summary.count
        return acc
      }, {})
      Object.keys(this.reservedLicenseQuantities).forEach(planCode => {
        quantities[planCode] = (quantities[planCode] || 0) + this.reservedLicenseQuantities[planCode]
      })
      return quantities
    },
    async loadBillingCalculation () {
      if (!this.isFirstBilling) {
        this.billingCalculation = {
          baseMonthlyFee: this.contractedMonthlyFee,
          proratedFee: this.contractedMonthlyFee,
          totalAmount: this.contractedMonthlyFee
        }
        return
      }

      const quantities = this.aggregateUsersByPlan()
      const totalUsers = Object.values(quantities).reduce((sum, qty) => sum + qty, 0)

      if (totalUsers === 0) {
        return
      }

      if (!this.effectiveBillingDay) {
        return
      }

      // Cálculos seguidos podem responder fora de ordem: só vale o último pedido.
      this.billingRequestId++
      const requestId = this.billingRequestId
      this.isLoadingBilling = true
      this.billingError = null

      try {
        const calculation = await calculateProrata(
          this.effectiveBillingDay,
          quantities
        )
        if (requestId === this.billingRequestId) this.billingCalculation = calculation
      } catch (error) {
        if (requestId !== this.billingRequestId) return
        console.error('Erro ao calcular pró-rata:', error)
        this.billingError = (error.response && error.response.data && error.response.data.message) || 'Erro ao calcular pró-rata'
        this.billingCalculation = null
      } finally {
        if (requestId === this.billingRequestId) this.isLoadingBilling = false
      }
    },
    async loadCycleCalculation () {
      if (!this.effectiveBillingDay) {
        return
      }

      try {
        const cycle = await billingService.calculateCycle(this.effectiveBillingDay)
        this.cycleCalculation = cycle
      } catch (error) {
        console.error('Erro ao calcular ciclo:', error)
        this.cycleCalculation = null
      }
    },
    async reloadBillingData () {
      await Promise.all([
        this.loadBillingCalculation(),
        this.loadCycleCalculation()
      ])
    },
    initializeUserPlans () {
      Object.keys(this.usersMonthlyUsage).forEach(planCode => {
        this.usersMonthlyUsage[planCode].forEach(user => {
          this.$set(this.userSelectedPlans, user.email || user.extension, planCode)
        })
      })
    },
    getUserPlan (user) {
      return this.userSelectedPlans[user.email || user.extension] || 'manager'
    },
    countUsersWithSelectedPlan (planCode) {
      let userCount = 0
      Object.keys(this.usersMonthlyUsage).forEach(originalPlanCode => {
        this.usersMonthlyUsage[originalPlanCode].forEach(user => {
          const selectedPlanCode = this.getUserPlan(user)
          if (selectedPlanCode === planCode) {
            userCount++
          }
        })
      })
      return userCount
    },
    goBack () {
      this.$router.push({ name: 'subscription' })
    },
    formatUserSeconds (seconds) {
      const totalMinutes = convertSecondsToCustomTimeFormat(Number(seconds), 'mm')
      if (totalMinutes === '00') {
        return '0 min'
      }
      return `${totalMinutes} min`
    },
    formatUserCurrency (value) {
      return this.formatCurrency(Number(value))
    },
    formatUserPercentage (value) {
      return formatPercentage(Number(value))
    },
    getPlanCardClasses (planCode) {
      return getPlanCardClassesUtil(planCode)
    },
    getPlanBadgeClasses (planCode) {
      return getPlanBadgeClassesUtil(planCode)
    },
    formatCurrency (value) {
      return formatCurrencyUtil(value)
    },
    formatPrice (value) {
      if (value === 0) {
        return 'Grátis'
      }
      return this.formatCurrency(value)
    },
    getPlanName (planCode) {
      const plan = this.pricingList.find(p => p.code === planCode)
      return plan ? plan.name : planCode
    },
    generateTableHtml () {
      let html = `
        <div style="width: 100%; border-collapse: collapse; border: 1px solid #e5e7eb; font-family: sans-serif;">
          <h1 style="text-align: center; font-size: 24px; font-weight: 600;">Plano de assinatura configurado para ${this.$store.state.auth.organization.name} - ${getMonthName(JSON.parse(this.selectedFilterDate).monthAgo)}</h1>
          <p style="text-align: center; font-size: 16px; font-weight: 400;">Email: ${this.$store.state.auth.user.email} (${this.$store.state.auth.organization.domain})</p>
        </div>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #e5e7eb; font-family: sans-serif;">
          <thead>
            <tr style="background-color: #f9fafb; border-bottom: 2px solid #e5e7eb;">
              <th style="padding: 12px; text-align: center; border: 1px solid #e5e7eb; font-weight: 600;">Usuários</th>
              <th style="padding: 12px; text-align: center; border: 1px solid #e5e7eb; font-weight: 600; background-color: #eff6ff;">Plano</th>
              <th style="padding: 12px; text-align: center; border: 1px solid #e5e7eb; font-weight: 600;">Tempo total em atendimento</th>
              <th style="padding: 12px; text-align: center; border: 1px solid #e5e7eb; font-weight: 600;">Consumo total (R$)</th>
              <th style="padding: 12px; text-align: center; border: 1px solid #e5e7eb; font-weight: 600;">Variação (R$)</th>
              <th style="padding: 12px; text-align: center; border: 1px solid #e5e7eb; font-weight: 600; background-color: #eff6ff;">Mensalidade total (R$)</th>
            </tr>
          </thead>
          <tbody>
      `

      // Uma seção por plano com usuários — inclusive os planos com IA4COM, que não têm
      // bloco próprio: a tabela é montada a partir do que o cliente escolheu, não de uma
      // lista fixa de planos.
      this.planSummaries.forEach(summary => {
        const badge = planBadgePalette(summary.plan.code)
        const badgeStyle = `background-color: ${badge.background}; color: ${badge.text}; border-radius: 9999px; font-weight: 600;`
        const feeLabel = summary.plan.monthlyFee === 0 ? 'Grátis' : this.formatUserCurrency(summary.monthlyFee)
        const isSaving = summary.variability <= 0
        html += `
            <tr style="background-color: #f9fafb; border-bottom: 1px solid #e5e7eb;">
              <td style="padding: 12px; text-align: center; border: 1px solid #e5e7eb; font-weight: bold;">${summary.count} usuários</td>
              <td style="padding: 12px; text-align: center; border: 1px solid #e5e7eb; background-color: #eff6ff;">
                <span style="${badgeStyle} padding: 4px 12px; font-size: 14px;">${summary.plan.name}</span>
              </td>
              <td style="padding: 12px; text-align: center; border: 1px solid #e5e7eb; font-weight: bold;">${this.formatUserSeconds(summary.seconds)}</td>
              <td style="padding: 12px; text-align: center; border: 1px solid #e5e7eb; font-weight: bold;">${this.formatUserCurrency(summary.cost)}</td>
              <td style="padding: 12px; text-align: center; border: 1px solid #e5e7eb; font-weight: bold; color: ${isSaving ? '#16a34a' : '#2563eb'};">
                ${isSaving ? '- ' : '+ '}${this.formatUserCurrency(Math.abs(summary.variability))}
              </td>
              <td style="padding: 12px; text-align: center; border: 1px solid #e5e7eb; background-color: #eff6ff; font-weight: bold; color: #16a34a;">${feeLabel}</td>
            </tr>
        `
        summary.users.forEach(user => {
          const monthlyFee = summary.plan.monthlyFee
          const userFeeLabel = monthlyFee === 0 ? 'Grátis' : this.formatUserCurrency(monthlyFee)
          const variability = monthlyFee - Number(user.cost || 0)
          html += `
            <tr style="background-color: #f9fafb; border-bottom: 1px solid #e5e7eb;">
              <td style="padding: 8px; padding-left: 32px; text-align: left; border: 1px solid #e5e7eb; font-size: 13px;">
                <div style="font-weight: 500;">${user.name || user.email}</div>
                <div style="color: #6b7280; font-size: 12px;">${user.email || user.extension}</div>
              </td>
              <td style="padding: 8px; text-align: center; border: 1px solid #e5e7eb; background-color: #eff6ff; font-size: 13px; color: #6b7280;">
                <span style="${badgeStyle} padding: 2px 8px; font-size: 11px;">${summary.plan.name}</span>
              </td>
              <td style="padding: 8px; text-align: center; border: 1px solid #e5e7eb; font-size: 13px;">${this.formatUserSeconds(user.seconds || 0)}</td>
              <td style="padding: 8px; text-align: center; border: 1px solid #e5e7eb; font-size: 13px;">${this.formatUserCurrency(user.cost || 0)}</td>
              <td style="padding: 8px; text-align: center; border: 1px solid #e5e7eb; font-size: 13px; color: ${variability <= 0 ? '#16a34a' : '#2563eb'}; font-weight: 500;">
                ${variability <= 0 ? '- ' : '+ '}${this.formatUserCurrency(Math.abs(variability))}
              </td>
              <td style="padding: 8px; text-align: center; border: 1px solid #e5e7eb; background-color: #eff6ff; font-size: 13px; font-weight: bold; color: #16a34a;">${userFeeLabel}</td>
            </tr>
          `
        })
      })

      // Total Geral
      html += `
            <tr style="background-color: #2463eb1a; border-top: 4px solid #2463eb; border-bottom: 1px solid #e5e7eb; font-weight: bold;">
              <td style="padding: 12px; text-align: center; border: 1px solid #e5e7eb;">TOTAL GERAL</td>
              <td style="padding: 12px; text-align: center; border: 1px solid #e5e7eb; background-color: #eff6ff;">${this.totalUsers} usuários</td>
              <td style="padding: 12px; text-align: center; border: 1px solid #e5e7eb;">${this.formatUserSeconds(this.totalSeconds)}</td>
              <td style="padding: 12px; text-align: center; border: 1px solid #e5e7eb;">${this.formatUserCurrency(this.totalCost)}</td>
              <td style="padding: 12px; text-align: center; border: 1px solid #e5e7eb; font-size: 16px; color: ${this.hasTotalNegativeVariability ? '#16a34a' : '#2563eb'};">
                ${this.hasTotalNegativeVariability ? '- ' : '+ '}${this.formatUserCurrency(Math.abs(this.totalVariability))}
                <br>
                <span style="font-size: 13px; font-weight: 500;">${this.formatUserPercentage(Math.abs(this.percentageVariability))}</span>
              </td>
              <td style="padding: 12px; text-align: center; border: 1px solid #e5e7eb; background-color: #eff6ff; font-size: 16px; color: #16a34a;">${this.formatUserCurrency(this.totalMonthlyFee)}</td>
            </tr>
          </tbody>
        </table>
      `

      // Resumo da Cobrança
      let summaryHtml = `
        <table style="width: 100%; border-collapse: collapse; border: 2px solid #86efac; border-radius: 8px; background-color: #dcfce7; margin-top: 24px; font-family: sans-serif;" cellpadding="0" cellspacing="0">
          <tr>
            <td style="padding: 24px; background-color: #dcfce7;">
              <table width="100%" cellpadding="0" cellspacing="0" style="border-collapse: collapse;">
                <tr>
                  <td colspan="2" style="padding-bottom: 12px;">
                    <h3 style="font-size: 18px; font-weight: 600; margin: 0; color: #1f2937; line-height: 1.2;">Resumo da Cobrança</h3>
                  </td>
                </tr>
                <tr>
                  <td width="50%" style="padding-right: 12px; vertical-align: top;">
                    <table width="100%" cellpadding="0" cellspacing="0" style="border-collapse: collapse;">
      `

      // Adicionar cada plano no resumo
      this.pricingList.forEach(plan => {
        const count = this.countUsersWithSelectedPlan(plan.code)
        if (count > 0) {
          const totalFee = plan.monthlyFee === 0 ? 0 : plan.monthlyFee * count
          summaryHtml += `
                      <tr>
                        <td style="padding: 6px 0; border-bottom: 1px solid #86efac; color: #65758b; font-size: 14px;">Plano ${plan.name} (${count}x)</td>
                        <td style="padding: 6px 0; border-bottom: 1px solid #86efac; text-align: right; font-weight: 500; font-size: 14px; color: #1f2937;">${plan.monthlyFee === 0 ? 'Grátis' : this.formatUserCurrency(totalFee)}</td>
                      </tr>
          `
        }
      })

      // Total e Pró-rata
      summaryHtml += `
                      <tr>
                        <td colspan="2" style="padding-top: 16px;">
                          <table width="100%" cellpadding="0" cellspacing="0" style="border-collapse: collapse; border-top: 2px solid #86efac;">
                            ${this.isFirstBilling ? `
                            <tr>
                              <td style="padding: 8px 0; font-size: 18px; font-weight: bold; color: #1f2937;">Total</td>
                              <td style="padding: 8px 0; text-align: right; font-size: 18px; font-weight: bold; color: #16a34a;">${this.formatUserCurrency(this.baseMonthlyFee)}</td>
                            </tr>
                            <tr>
                              <td colspan="2" style="padding-top: 8px; border-top: 1px solid #86efac;">
                                <table width="100%" cellpadding="0" cellspacing="0" style="border-collapse: collapse;">
                                  <tr>
                                    <td style="padding: 4px 0; font-size: 14px; color: #65758b;">Cobrança proporcional até o próximo ciclo (pró-rata)</td>
                                    <td style="padding: 4px 0; text-align: right; font-size: 14px; font-weight: 600; color: #16a34a;">${this.formatUserCurrency(this.totalMonthlyFee)}</td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                            ` : `
                            <tr>
                              <td style="padding: 8px 0; font-size: 18px; font-weight: bold; color: #1f2937;">Total</td>
                              <td style="padding: 8px 0; text-align: right; font-size: 18px; font-weight: bold; color: #16a34a;">${this.formatUserCurrency(this.totalMonthlyFee)}</td>
                            </tr>
                            `}
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td width="50%" style="padding-left: 12px; vertical-align: top;">
                    <table width="100%" cellpadding="0" cellspacing="0" style="border-collapse: collapse; background-color: rgba(255, 255, 255, 0.8); border: 1px solid #86efac; border-radius: 8px;">
                      <tr>
                        <td style="padding: 16px;">
                          <table width="100%" cellpadding="0" cellspacing="0" style="border-collapse: collapse;">
                            <tr>
                              <td style="padding-bottom: 8px;">
                                <table cellpadding="0" cellspacing="0" style="border-collapse: collapse;">
                                  <tr>
                                    <td style="padding-right: 8px; vertical-align: middle;">
                                      <span style="color: #16a34a; font-size: 20px;">📅</span>
                                    </td>
                                    <td style="vertical-align: middle;">
                                      <span style="font-weight: 600; font-size: 14px; color: #1f2937;">Vencimento desta cobrança</span>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td style="padding-bottom: 16px;">
                                <p style="font-size: 24px; font-weight: bold; margin: 0; color: #1f2937; line-height: 1.2;">${this.formattedCurrentBillingDueDate || 'Não definido'}</p>
                                ${this.currentPeriodDisplay ? `<p style="font-size: 12px; color: #65758b; margin: 4px 0 0 0; line-height: 1.2;">Período: ${this.currentPeriodDisplay}</p>` : ''}
                              </td>
                            </tr>
                            <tr>
                              <td style="padding-top: 12px; border-top: 1px solid #86efac;">
                                <p style="font-size: 14px; color: #65758b; margin: 0; line-height: 1.5;">
                                  Vencimento das próximas cobranças: dia <span style="font-weight: 500; color: #1f2937;">${this.effectiveBillingDay}</span> de cada mês
                                </p>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      `

      return html + summaryHtml
    },
    generatePayment () {
      this.isLoadingPayment = true
      this.journeyActive = false
      this.journeyEmittedPayment = false
      this.journeyAbandonmentSent = false
      this.journeyContext = null
      const isFree = this.contractedMonthlyFee <= 0

      return this.fetchHasPaidCharges()
        .then(hasPaidCharges => {
          const dealPrefix = hasPaidCharges ? 'MIGRAÇÃO' : 'NOVO PLANO'

          const payload = {
            organizationName: this.$store.state.auth.organization.name,
            organizationDomain: this.$store.state.auth.organization.domain,
            userEmail: this.$store.state.auth.user.email,
            userName: this.$store.state.auth.user.name,
            userPhone: this.$store.state.auth.user.phone,
            month: getMonthName(JSON.parse(this.selectedFilterDate).monthAgo),
            totalUsers: this.totalUsers,
            totalSeconds: this.totalSeconds,
            totalCost: this.totalCost,
            totalMonthlyFee: this.totalMonthlyFee,
            totalVariability: this.totalVariability,
            percentageVariability: this.percentageVariability,
            usersMonthlyUsage: this.usersMonthlyUsage,
            tableHtml: this.generateTableHtml(),
            dealPrefix
          }

          const applyAfterWebhook = async () => {
            if (isFree) {
              this.openContactPhoneModal()
            } else {
              await this.openPaymentMethodModal()
              this.journeyContext = {
                organizationName: this.$store.state.auth.organization.name,
                organizationDomain: this.$store.state.auth.organization.domain,
                accountId: this.$store.state.auth.organization && this.$store.state.auth.organization.uuid,
                userEmail: this.$store.state.auth.user.email,
                userName: this.$store.state.auth.user.name,
                userPhone: this.$store.state.auth.user.phone,
                dealPrefix
              }
              this.journeyActive = true
            }
          }

          const webhookUrl = process.env.API4COM_SUBSCRIPTION_PRICING_WEBHOOK_URL
          if (!webhookUrl) {
            console.warn('api4com > subscriptions > pricing > webhook URL not configured')
            return applyAfterWebhook()
          }

          return axios.post(webhookUrl, payload, {
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(async response => {
            console.log('api4com > subscriptions > pricing > webhook sent successfully', response)
            await applyAfterWebhook()
            return response
          }).catch(async err => {
            console.error('api4com > subscriptions > pricing > webhook error', err)
            await applyAfterWebhook()
            throw err
          })
        })
        .finally(() => {
          this.isLoadingPayment = false
        })
    },
    openContactPhoneModal () {
      this.contactPhone = maskNationalPhone(this.$store.state.auth.user.phone)
      this.showContactPhoneModal = true
    },
    closeContactPhoneModal () {
      this.showContactPhoneModal = false
    },
    allowOnlyNumericKeydown,
    onContactPhoneInput () {
      const digits = phoneDigitsOnly(this.contactPhone)
      this.contactPhone = formatPhoneMask(digits)
    },
    confirmContactPhone () {
      if (!this.isContactPhoneValid || this.isUpdatingPhone) return
      this.isUpdatingPhone = true
      const digits = phoneDigitsOnly(this.contactPhone)
      const currentUser = this.$store.state.auth.user
      const previousPhone = phoneDigitsOnly(currentUser && currentUser.phone)
      const phoneChanged = digits !== previousPhone
      // Envia o email do usuário LOGADO para o PATCH atualizar o próprio usuário
      // (isSelfUpdate). Sem email, o backend cai no 1º usuário da org (founder) e o
      // setUser trocaria a sessão.
      loopback
        .patch('/users', { email: currentUser && currentUser.email, phone: digits })
        .then(user => {
          this.$store.commit('auth/setUser', user)
          if (phoneChanged) {
            triggerUserDataUpdateWebhook({
              email: user.email,
              name: user.name,
              phone: user.phone,
              domain: this.$store.state.auth.organization.domain
            })
          }
          this.showContactPhoneModal = false
        })
        .catch(err => {
          console.error('api4com > subscription > phone update error', err)
        })
        .finally(() => {
          this.isUpdatingPhone = false
        })
    },
    async openPaymentMethodModal () {
      const accountId = this.$store.state.auth.organization && this.$store.state.auth.organization.uuid
      if (accountId) {
        try {
          const response = await billingService.getPendingInvoices()
          if (response && response.meta && response.meta.total > 0 && Array.isArray(response.items) && response.items.length > 0) {
            this.pendingInvoiceData = {
              total: response.meta.total,
              externalUrl: response.items[0].externalUrl || null
            }
          } else {
            this.pendingInvoiceData = null
          }
        } catch (err) {
          this.pendingInvoiceData = null
        }
      }
      this.showPaymentMethodModal = true
      this.subscriptionError = null
      this.invoiceLoadingLabel = 'Gerando cobrança...'
    },
    sendJourneyAbandonment () {
      if (this.journeyActive === false || this.journeyAbandonmentSent === true) return
      this.journeyAbandonmentSent = true

      const webhookUrl = process.env.API4COM_SUBSCRIPTION_ABANDONMENT_WEBHOOK_URL
      if (!webhookUrl) {
        console.warn('api4com > subscriptions > abandonment > webhook URL not configured')
        return
      }

      const payload = {
        ...this.journeyContext,
        paymentIssued: this.journeyEmittedPayment
      }

      axios.post(webhookUrl, payload, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        console.log('api4com > subscriptions > abandonment > webhook sent successfully', response)
      }).catch(err => {
        console.error('api4com > subscriptions > abandonment > webhook error', err)
      })
    },
    endJourney () {
      this.journeyActive = false
    },
    handlePaymentMethodModalClose () {
      this.sendJourneyAbandonment()
      this.closePaymentMethodModal()
      this.endJourney()
    },
    closePaymentMethodModal () {
      this.showPaymentMethodModal = false
      this.subscriptionError = null
      this.pendingInvoiceData = null
    },
    closeFinancialDocumentModal () {
      this.showFinancialDocumentModal = false
      this.pendingConfirmPayload = null
      this.showPaymentMethodModal = true
    },
    async handleFinancialDocumentContinue () {
      this.showFinancialDocumentModal = false
      const confirmPayload = this.pendingConfirmPayload
      this.pendingConfirmPayload = null
      if (confirmPayload) {
        this.showPaymentMethodModal = true
        await this.finalizeSubscriptionCheckout(confirmPayload)
      }
    },
    async handlePaymentMethodConfirm (confirmPayload) {
      if (this.needsFinancialDocument) {
        this.pendingConfirmPayload = confirmPayload
        this.showPaymentMethodModal = false
        this.showFinancialDocumentModal = true
        return
      }
      await this.finalizeSubscriptionCheckout(confirmPayload)
    },
    async finalizeSubscriptionCheckout (confirmPayload) {
      this.subscriptionError = null
      this.isLoadingPayment = true
      const paymentWindow = window.open('', '_blank')
      let paymentWindowUsed = false
      if (paymentWindow) {
        const doc = paymentWindow.document
        doc.title = 'Gerando cobrança...'
        const style = doc.createElement('style')
        style.textContent = `
          body { margin: 0; height: 100vh; display: flex; flex-direction: column;
                 align-items: center; justify-content: center; font-family: sans-serif;
                 color: #555; gap: 16px; }
          .spinner { width: 40px; height: 40px; border: 4px solid #eee;
                     border-top-color: #22c55e; border-radius: 50%;
                     animation: spin 0.8s linear infinite; }
          @keyframes spin { to { transform: rotate(360deg); } }
        `
        doc.head.appendChild(style)
        doc.body.innerHTML = '<div class="spinner"></div><p>Gerando sua cobrança, aguarde...</p>'
      }
      try {
        const result = await runSubscriptionCheckout(this, confirmPayload)
        if (result.success) {
          this.chargeGeneratedPaymentLink = result.paymentLink
          this.chargeGeneratedNetValue = result.netValue !== undefined ? result.netValue : null
          this.chargeGeneratedDueDate = result.dueDate !== undefined ? result.dueDate : null
          this.journeyEmittedPayment = true
          this.closePaymentMethodModal()
          this.showChargeGeneratedModal = true
          const paymentLink = typeof result.paymentLink === 'string' ? result.paymentLink.trim() : ''
          if (paymentLink && paymentWindow) {
            paymentWindow.opener = null
            paymentWindow.location.href = paymentLink
            paymentWindowUsed = true
          }
        }
      } finally {
        this.isLoadingPayment = false
        if (paymentWindow && !paymentWindowUsed) {
          paymentWindow.close()
        }
      }
    },
    handleChargeGeneratedModalClose () {
      this.sendJourneyAbandonment()
      this.dismissChargeGeneratedModal()
      this.endJourney()
    },
    closeChargeGeneratedModal () {
      this.sendJourneyAbandonment()
      this.dismissChargeGeneratedModal()
      this.endJourney()
      this.$router.push({ name: 'usersList' })
    },
    dismissChargeGeneratedModal () {
      this.showChargeGeneratedModal = false
      this.chargeGeneratedPaymentLink = ''
      this.chargeGeneratedNetValue = null
      this.chargeGeneratedDueDate = null
    },
    formatCycleDisplay (startDate, endDate) {
      const daysInCycle = endDate.diff(startDate, 'days') + 1
      return `Ciclo: ${startDate.format('DD/MM')} - ${endDate.format('DD/MM')}<span class="ml-1">(${daysInCycle} dias)</span>`
    },
    getClosestAvailableBillingDay (currentDay) {
      // TEL-2041: dia de vencimento real (1-31), sem clamp para 28. O billing
      // deriva o dia da data de contratação e normaliza meses curtos; o front
      // precisa espelhar isso para não exibir um dia divergente da cobrança real.
      const options = Array.from({ length: 31 }, (_, i) => i + 1)

      const distances = options.map(day => ({
        day: day,
        distance: Math.abs(currentDay - day)
      }))

      const minDistance = Math.min(...distances.map(d => d.distance))

      const closest = distances
        .filter(d => d.distance === minDistance)
        .sort((a, b) => a.day - b.day)[0]

      return closest.day
    },
    openDueDateModal () {
      if (!this.selectedBillingDay || this.selectedBillingDay === 10) {
        const todayDay = moment().date()
        const suggestedDay = this.getClosestAvailableBillingDay(todayDay)
        this.selectedBillingDay = suggestedDay
      }

      this.previewBillingDay = this.selectedBillingDay
      this.showDueDateModal = true
      document.body.style.overflow = 'hidden'
    },
    closeDueDateModal () {
      this.showDueDateModal = false
      this.isDayDropdownOpen = false
      document.body.style.overflow = ''
    },
    toggleDayDropdown () {
      this.isDayDropdownOpen = !this.isDayDropdownOpen
    },
    selectBillingDay (day) {
      this.previewBillingDay = day
      this.isDayDropdownOpen = false
    },
    saveBillingDaySelection () {
      this.selectedBillingDay = this.previewBillingDay
      this.closeDueDateModal()
      this.reloadBillingData()
    },
    handleOutsideClick (event) {
      if (this.isDayDropdownOpen && !event.target.closest('.relative')) {
        this.isDayDropdownOpen = false
      }
      if (this.isAiModelDropdownOpen && !event.target.closest('.ai-model-dropdown-container')) {
        this.isAiModelDropdownOpen = false
      }
    },
    toggleAiModelDropdown () {
      this.isAiModelDropdownOpen = !this.isAiModelDropdownOpen
    },
    selectAiModel (value) {
      this.selectedAiModel = value
      this.isAiModelDropdownOpen = false
    },
    async fetchAiModels () {
      try {
        const list = await getAiModels()
        const safeList = Array.isArray(list) ? list : []
        const mapped = safeList
          .filter(item => item && typeof item.name === 'string' && item.name.trim() !== '')
          .map(item => ({
            value: item.name,
            label: labelForAiModel(item.name)
          }))
        this.aiModels = mapped
        if (this.selectedAiModel === null && mapped.length > 0) {
          const preferred = mapped.find(model => model.value === AI_MODEL_DEFAULT)
          this.selectedAiModel = preferred ? preferred.value : mapped[0].value
        }
      } catch (error) {
        console.error('Failed to load AI models', error)
        this.aiModels = []
      }
    },
    // Migração x novo plano é a mesma pergunta que o comercial faz no deal:
    // a conta já pagou alguma cobrança? Serve também para quem volta da
    // recarga (inadimplência ou cancelamento) e contrata de novo.
    fetchHasPaidCharges () {
      return loopback
        .get('/charges', { params: { page: 1, filter: { where: { status: 'PAID' }, limit: 1 } } })
        .then(charges => {
          if (Array.isArray(charges)) return charges.length > 0
          return !!(charges && charges.data && charges.data.length > 0)
        })
    },
    loadPaidChargesFlag () {
      return this.fetchHasPaidCharges()
        .then(hasPaidCharges => {
          this.hasPaidCharges = hasPaidCharges
        })
        .catch(() => {
          // Sem resposta, trata como conta nova: o texto de migração afirma um
          // histórico que talvez não exista.
          this.hasPaidCharges = false
        })
    },
    handleRedesignPick ({ user, planCode }) {
      if (this.pricingList.some(plan => plan.code === planCode)) {
        this.$set(this.userSelectedPlans, user.key, planCode)
      } else {
        this.$delete(this.userSelectedPlans, user.key)
      }
    },
    handleRedesignApplyAll (planCode) {
      this.redesignUsers.forEach(user => {
        this.$set(this.userSelectedPlans, user.key, planCode)
      })
    },
    handleRedesignResetSuggestions () {
      this.userSelectedPlans = {}
      this.initializeUserPlans()
    },
    handleRedesignMonthChange (value) {
      this.selectedFilterDate = value
      this.updateUsersMonthlyUsage()
    },
    // Cada clique no +/− das licenças pediria um cálculo; espera os cliques pararem.
    handleRedesignLicensesChange (licenses) {
      this.reservedLicenses = licenses
      if (this.licensesReloadTimer !== null) clearTimeout(this.licensesReloadTimer)
      this.licensesReloadTimer = setTimeout(() => {
        this.licensesReloadTimer = null
        this.reloadBillingData()
      }, LICENSES_RELOAD_DEBOUNCE_MS)
    },
    handleRedesignSubmit (payload) {
      // Licenças reservadas viram assento sem `userId` no item do plano
      // (`buildSubscriptionItems`): capacidade contratada, ainda não atribuída.
      this.reservedLicenses = payload.licenses
      // Clique no +/− ainda esperando o cálculo: recalcula antes, senão a cobrança
      // sairia com o total da quantidade anterior.
      if (this.licensesReloadTimer !== null) {
        clearTimeout(this.licensesReloadTimer)
        this.licensesReloadTimer = null
        return this.reloadBillingData().then(() => this.generatePayment())
      }
      this.generatePayment()
    },
    loadRolloutAiDropdown () {
      loopback
        .get('/rollout?featureFlag=enable-ai-dropdown')
        .then(rollout => {
          this.isRolloutAiDropdown = rollout === 'ALLOWED'
        })
        .catch(() => {
          this.isRolloutAiDropdown = false
        })
    },
    async updateUsersMonthlyUsage () {
      this.error = null
      this.isLoadingUsage = true
      this.usersMonthlyUsage = {}
      processUsersMonthlyUsage(JSON.parse(this.selectedFilterDate), this.pricingList).then(usersUsage => {
        this.usersMonthlyUsage = normalizeUsageGroups(usersUsage)
        this.initializeUserPlans()
        this.reloadBillingData()
      }).catch(err => {
        this.error = err
        console.error('on change filter date error', err)
      }).finally(() => {
        this.isLoadingUsage = false
      })
    }
  },
  watch: {
    effectiveBillingDay: {
      handler () {
        this.reloadBillingData()
      },
      immediate: false
    },
    userSelectedPlans: {
      handler () {
        this.reloadBillingData()
      },
      deep: true,
      immediate: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import './Pricing.scss';

// Largura toda da área ao lado do menu, como no Figma (TEL-2465): o layout do portal
// já dá 30px no topo e 15px dos lados; os 16px daqui completam a margem lateral.
.pricing-main {
  display: block;
  padding: 0 16px;
}

.ai-model-title-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.ai-model-info {
  position: relative;
  display: inline-flex;
  align-items: center;
  color: #6b7280;
  cursor: help;
  outline: none;

  &:hover,
  &:focus,
  &:focus-visible {
    color: #2463eb;
  }

  &__tooltip {
    position: absolute;
    bottom: calc(100% + 8px);
    left: 0;
    width: 260px;
    max-width: 80vw;
    padding: 8px 10px;
    background: #111827;
    color: #f9fafb;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1.35;
    text-align: left;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.15s ease;
    z-index: 60;
    pointer-events: none;

    strong {
      font-weight: 600;
    }
  }

  &__tooltip::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 12px;
    border: 5px solid transparent;
    border-top-color: #111827;
  }

  &:hover &__tooltip,
  &:focus &__tooltip,
  &:focus-visible &__tooltip {
    opacity: 1;
    visibility: visible;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Subscription/Pricing.vue